var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgErrorIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.5694 17.5194L14.4192 4.34875C13.8972 3.50415 12.9928 3 12 3C11.0071 3 10.1028 3.5042 9.58074 4.34875L9.581 4.34836L1.4304 17.5198C0.880401 18.4096 0.856166 19.4863 1.36552 20.4C1.87487 21.3137 2.80352 21.8592 3.84959 21.8592H20.1504C21.1965 21.8592 22.1251 21.3137 22.6345 20.4C23.1439 19.4863 23.1196 18.4096 22.5694 17.5194ZM21.1336 19.5633C20.932 19.9249 20.5644 20.1408 20.1504 20.1408H3.84959C3.43555 20.1408 3.06799 19.9249 2.86638 19.5633C2.66477 19.2016 2.67435 18.7754 2.89182 18.4237L11.0422 5.25264L11.0425 5.25226C11.2522 4.91297 11.6012 4.71841 12 4.71841C12.3989 4.71841 12.7478 4.91297 12.9578 5.2526L21.1079 18.4233C21.3256 18.7754 21.3353 19.2016 21.1336 19.5633ZM11.1409 17.7781C11.1409 18.2526 11.5255 18.6372 12 18.6372C12.4746 18.6372 12.8592 18.2526 12.8592 17.7781C12.8592 17.3035 12.4746 16.9189 12 16.9189C11.5255 16.9189 11.1409 17.3035 11.1409 17.7781ZM12.8592 9.31502V14.3413C12.8592 14.8158 12.4746 15.2005 12 15.2005C11.5255 15.2005 11.1409 14.8158 11.1409 14.3413V9.31502C11.1409 8.8405 11.5255 8.45583 12 8.45583C12.4746 8.45583 12.8592 8.8405 12.8592 9.31502Z",
    fill: "#F14055"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorIcon);
export default __webpack_public_path__ + "static/media/errorIcon.2d6cec00fd23f07198b2b080cf14cded.svg";
export { ForwardRef as ReactComponent };